import type { MouseEventHandler } from 'react';

import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import ReviewParagraphs from '../../../ReviewParagraphs';
import ReviewRating from '../../../ReviewRating';

import type { Review } from '@shared/types/frontend/ubff/hotel-reviews';

import STYLES from './MiniReviewCard.module.scss';

import CountryFlag from '@hotels-hotel-detail/ui/CountryFlag';

const cls = cssModules(STYLES);

type Props = {
  review: Review;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

const MiniReviewCard = ({ onClick, review }: Props) => {
  const {
    checkinDate,
    country,
    guestType,
    logo,
    partner,
    rating,
    review: reviewContent,
    reviewDate,
    title,
  } = review;

  return (
    <button className={cls('MiniReviewCard')} onClick={onClick} type="button">
      <div className={cls('MiniReviewCard__guestDescription')}>
        <div className={cls('MiniReviewCard__guestRating')}>
          <BpkText
            textStyle={TEXT_STYLES.label2}
            color={TEXT_COLORS.textPrimary}
          >
            {guestType}
          </BpkText>
          <ReviewRating logo={logo} rating={rating} partner={partner} />
        </div>
        {country && <CountryFlag text={country.code} url={country.flag} />}
      </div>
      <div className={cls('MiniReviewCard__dateContainer')}>
        {reviewDate && (
          <BpkText textStyle={TEXT_STYLES.caption} tagName="p">
            {reviewDate}
          </BpkText>
        )}
        {checkinDate && (
          <BpkText textStyle={TEXT_STYLES.caption} tagName="p">
            {checkinDate}
          </BpkText>
        )}
      </div>
      {title && (
        <BpkText
          textStyle={TEXT_STYLES.heading5}
          color={TEXT_COLORS.textPrimary}
          tagName="p"
          className={cls('MiniReviewCard__reviewTitle')}
        >
          {title}
        </BpkText>
      )}
      <div className={cls('MiniReviewCard__reviewContent')}>
        <ReviewParagraphs review={reviewContent} />
      </div>
    </button>
  );
};

export default MiniReviewCard;
